// services/myPostHistory.js
import axios from "axios";

/* =========================================================
   👤 FETCH MY POSTS (cursor-based pagination — X-style)
   cursor = ISO timestamp of the oldest post currently loaded
========================================================= */
export const fetchMyPostHistory = async ({
  limit  = 50,
  cursor = null,   // pass null on first load, nextCursor on subsequent calls
} = {}) => {
  try {
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) params.set("cursor", cursor);

    const res = await axios.get(`/api/myposts?${params.toString()}`, {
      withCredentials: true,
    });


    return {
      success:    res.data?.success    || false,
      count:      res.data?.count      || 0,
      posts:      Array.isArray(res.data?.posts) ? res.data.posts : [],
      nextCursor: res.data?.nextCursor || null,
      hasMore:    res.data?.hasMore    || false,
    };
  } catch (err) {
    throw err;
  }
};